import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";
import { useIsRedesignEnabled } from "@src/appV2/redesign/hooks/useIsRedesignEnabled";
import { Platform } from "@src/mobile/utils/platform";

export function useIsMonthlyViewEnabled(): boolean {
  const isRedesignEnabled = useIsRedesignEnabled();
  const isMonthlyViewEnabled = useCbhFlag(CbhFeatureFlag.ENABLE_MONTHLY_VIEW, {
    defaultValue: false,
  });

  return isRedesignEnabled && (Platform.isMobile || isMonthlyViewEnabled);
}
